import { UserContact } from './business-types';
import { EntityInfo } from './platform-types';

export interface UserInfo extends EntityInfo {
  uniqueid: string;
  username: string;
  initials: string;
}

export interface Creatable {
  createdBy: UserInfo;
  createdOn: string;
}

export interface Modifiable {
  modifiedBy: UserInfo | null;
  modifiedOn: string | null;
}

export interface Archivable {
  archivedBy: UserInfo | null;
  archivedOn: string | null;
}

export type UserDetail = UserInfo & UserContact;

export function getUserNameWithoutDomain(user: UserInfo | UserContact) {
  return user.username.split('\\').reverse()[0];
}
